import Axios from "../../axios-default"
import AxiosPush from "../../axios-push"
import router from "../../router"
import i18n from '../../i18n'
import vuetify from '../../plugins/vuetify'

const state = {
  token: 0,
  email: 'anonymous@user',
  lang: 'pl',
  dark: false,
  notifi: false
};

const getters = {
  token: state => {
    //return '3eced465abde802fbf1bb091a4a16972';
    //20543466574D510D
    //2053356854325701
    if (state.token != 0) {
      return state.token;
    } else {
      return localStorage.getItem('token');
    }
  },
  isAuthenticated (state) {
    return (typeof state.token === 'string') ? state.token.length > 16 : false
  }
};

const mutations = {
  authUser(state, userData) {
    state.token = userData.token;
    state.email = userData.email;
  },
  unauthUser(state) {
    state.token = 0;
    state.email = 0;
    //state.controllers = null;
  },
  resurectUser(state, userData) {
    state.token = userData.token;
    state.email = userData.email;
    state.lang = userData.lang;
    state.dark = userData.dark;
    state.notifi = userData.notifi;
    
    i18n.locale = userData.lang;
    vuetify.framework.theme.dark = userData.dark;
  },
  setLang(state, lang) {
    state.lang = lang;
    i18n.locale = lang;
  },
  setNotifi(state, notifications) {
    state.notifi = notifications;
  },
  setDark(state, dark) {
    state.dark = dark;
    vuetify.framework.theme.dark = dark;
  },
};

const actions = {
  signup ({commit}, authData) {
    return Axios.post('/api/uzytkownik/rejestracja?t='+Date.now(), authData)
    .then(res => {
      if (typeof res.data !== 'object') {
        return {error: { code: '0'}}
      } else {
        return res.data;
      }
    })
    .catch(error => console.log(error))
  },
  login ({dispatch, commit}, authData) {
    return Axios.post('/api/uzytkownik/logowanie?t='+Date.now(), authData)
    .then(res => {
      console.log(res);
      if (typeof res.data !== 'object') {
        res.data = {error: { code: '0'}}
      } else {
        if (res.data.token) {
          commit('authUser', {
            token: res.data.token,
            email: res.data.email
          });
          dispatch('save');
        }
        return res.data;
      }
    })
    .catch(error => { return { error: { code: '0'}}})
  },
  remind ({commit}, authData) {
    return Axios.post('/api/uzytkownik/przypomnienie-hasla?t='+Date.now(), authData)
    .then(res => {
      if (typeof res.data !== 'object') {
        return {error: { code: '0'}}
      } else {
        return res.data;
      }
    })
    .catch(error => { return { error: { code: '0'}}})
  },
  newpass ({dispatch, commit}, authData) {
    return Axios.post('/api/uzytkownik/przypomnienie-hasla-2?t='+Date.now(), authData)
    .then(res => {
      if (res.data.token) {
        commit('authUser', {
          token: res.data.token
        });
        dispatch('save');
        return 'success';
      } else if (res.data.error.code) {
        return res.data.error.code;
      } else {
        return 'error';
      }
    })
    .catch(error => { return { error: { code: '0'}}})
  },
  changepass ({dispatch, commit}, authData) {
    return Axios.post('/api/uzytkownik/zmiana-hasla?t='+Date.now(), authData)
    .then(res => {
      if (typeof res.data !== 'object') {
        return {error: { code: '0'}}
      } else {
        if (res.data.token) {
          commit('authUser', {
            token: res.data.token,
            email: res.data.email
          });
          dispatch('save');
        }
        return res.data;
      }
    })
    .catch(error => { return { error: { code: '0'}}})
  },
  confirm ({commit}, authData) {
    return Axios.post('/api/uzytkownik/rejestracja/potwierdzenie?t='+Date.now(), authData)
    .then(res => {
      if (typeof res.data !== 'object') {
        return {error: { code: '0'}}
      } else {
        if (res.data.email) {
          return res.data;
        } else {
          return {error: { code: '0'}}
        }
      }
    })
    .catch(error => { return { error: { code: '0'}}})
  },
  async sendSubscriptionToServer({commit, state}, subscription) {
    const res = await AxiosPush.post('/subscription.php?t=' + Date.now(), 
      JSON.stringify({
        email: state.email,
        subscription: subscription
      })
    );

    if (typeof res.data !== 'object') {
      res.data = {error:{code:'0'}};
    } else {
      return res.data;
    }
  },
  logout ({dispatch, commit}) {
    commit('unauthUser');
    dispatch('forgetControllers');
    dispatch('save');
    router.replace('/')
  },
  unauth ({commit}) {
    commit('unauthUser');
  },
  save ({commit, state}) {
    localStorage.setItem('state', JSON.stringify(state));
    localStorage.setItem('token', state.token);
  },
  resurrect ({commit}) {
    if (localStorage.getItem('state')) { 
      commit('resurectUser', JSON.parse(localStorage.getItem('state')));
    }
  },
  setLang ({dispatch, commit}, lang) {
    commit('setLang', lang);
    dispatch('save');
  },
  setNotifi({dispatch, commit}, notifications) {
    commit('setNotifi', notifications);
    dispatch('save');
  },
  setDark({dispatch, commit}, dark) {
    commit('setDark', dark);
    dispatch('save');
  },
};

export default {
  state,
  getters,
  mutations,
  actions
}
